import { Component, ChangeDetectorRef } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { ToggelComponent } from '../../../design-system/toggel/toggel.component';
import { ToggleConfig } from '../../../design-system/toggel/toggle.modal';

@Component({
  selector: 'toggle-renderer',
  templateUrl: './toggle-renderer.component.html',
  standalone: true,
  imports: [TranslateModule, ToggelComponent]
})
export class ToggleRendererComponent implements ICellRendererAngularComp {

  informationId: number;
  isEnabled: boolean;
  params: ICellRendererParams;
  isHidden: boolean = false;
  showText: boolean = false;
  showSwitchText2: string = "";
  switchOnText: string = 'Yes';
  switchOffText: string = 'No';
  toggleConfig: ToggleConfig = {
    label: '',
    labelPosition: 'right',
    size: 'md',
    isActive: false,
    disabled: false,
    id: '',
    isLabel: true
  };
  constructor(private cdr: ChangeDetectorRef) { }

  initilize(params: ICellRendererParams) {
    if (params.data) {
      this.params = params;
      if (params.data.informationId) {
        this.isEnabled = params.data.isSwitchedOn2;
        this.informationId = params.data.informationId;
        this.isHidden = params.data.isHidden;
        this.showText = params.data.showText;
        this.switchOnText = params.data.switchOnText ?? 'Yes';
        this.switchOffText = params.data.switchOffText ?? 'No';
        this.showSwitchText2 = this.isEnabled ? this.switchOnText : this.switchOffText;

        this.toggleConfig = {
          ...this.toggleConfig, label: this.showSwitchText2,
          isActive: this.isEnabled, id: this.informationId.toString(), isLabel: this.showText
        };
      }
    }
  }

  agInit(params: any): void {
    this.initilize(params);
  }

  refresh(params: any): boolean {
    this.initilize(params);
    return true;
  }

  onChange(isChecked: boolean) {
    this.isEnabled = isChecked;
    this.params.data.isSwitchedOn2 = isChecked;
    this.showSwitchText2 = this.isEnabled ? this.switchOnText : this.switchOffText;
    this.params.data.showSwitchText2 = this.showSwitchText2;
    this.toggleConfig = { ...this.toggleConfig, label: this.showSwitchText2, isActive: this.isEnabled };
    this.params.setValue(this.isEnabled);
    (this.params as any).onValueChanged?.(isChecked);
    this.cdr.detectChanges();
  }

}